import { makeStyles } from '@mui/styles';
const vehicleTotalPriceSideStyles = makeStyles(() => ({
    details: {},
    driveAwayLabel: {},
    driveAwayPrice: {
        wordBreak: 'keep-all',
        whiteSpace: 'break-spaces',
    },
    divider: {},
    driveAwayPriceContainer: {},
    driveAwayPriceLabel: {},
    priceContainer: {},
}), { name: 'Common_VehicleTotalPriceSide' });
export default vehicleTotalPriceSideStyles;
//# sourceMappingURL=vehicleTotalPriceSide.styles.js.map